/**
 * 路由权限页（登录判断）
 */
import router from './router'
import store from './store'

import Vue from 'vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// 链接白名单
const whiteList = ['login','h5View']
import { asyncRouterMap, constantRouterMap } from '@/router/routerList'


/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach((to, from, next) => {
  // 加载页面跳转动画
  NProgress.start()
  // token作为是否登录的验证
  if (Vue.ls.get('token')) {
    //     // 获取登录后访问登录页面直接跳转到首页
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      //  判断vuex内是否有权限数据 如果没有重新获取
      if (store.getters.rolesList.length === 0) {
        
        let socketClientID = `${Vue.ls.get('userId')}${new Date().getTime()}`
        Vue.ls.set('socketClientID', socketClientID)

        store.dispatch('STAFF_WEBSOCKET');
        
        store
          .dispatch('GetInfo')
          .then(roles => {
            // router.addRoutes(asyncRouterMap)
            // next({ ...to, replace: true })
            store.dispatch('GenerateRoutes', { roles }).then(() => {
              // 根据roles权限生成可访问的路由表
              // 动态添加可访问路由表
              router.addRoutes(store.getters.routers)
              const redirect = decodeURIComponent(from.query.redirect || to.path)
              if (to.path === redirect) {
                // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                next({ ...to, replace: true })
              } else {
                // 跳转到目的路由
                next({ path: redirect })
              }
            }).catch((e) => {
            });
          })
          .catch((err) => {
            console.log('error')
            // store.dispatch('Logout').then(() => {
            //     next({ path: '/login', query: { redirect: to.fullPath } })
            // })
          })
      } else {
        next()
      }

    }
  } else {
    if (whiteList.includes(to.name)) {
      next()
    } else {
      next('/login')
    }
  }
})

router.afterEach((to) => {
  NProgress.done()
})
